let _provider = null

const NON_PROD_ENVS = ['development', 'staging']

export function setFeatureFlagProvider (provider) {
  _provider = provider
}

export function getFeatureFlag (flagKey, defaultValue = false) {
  if (_provider) {
    try {
      return !!_provider.getFlag(flagKey, defaultValue)
    } catch (_) {}
  }
  if (NON_PROD_ENVS.includes(process.env.NODE_ENV)) {
    return true
  }
  return !!defaultValue
}
